// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.speakers h2 {
  margin-bottom: 5px;
  text-align: center;
}

.speakers .add {
  text-align: center;
}

.speakers .list::-webkit-scrollbar-track {
    border-radius: 20px;
    background: #efefef; /* color of the tracking area */
}
  
.speakers .list::-webkit-scrollbar-thumb {
    background-color: #0075ff; /* color of the scroll thumb */
    border-radius: 20px; /* roundness of the scroll thumb */
    border: 1px solid var(--default-icon-color); /* creates padding around scroll thumb */
}

.speakers .list::-webkit-scrollbar{
    width:12px;
}

.speakers .speaker {
  padding: 5px;
  margin-bottom: 5px;
  display: flex;
}

.speakers .speaker .picture {
  width: 22%;
  margin: auto;
  text-align: center;
}

.speakers .speaker .picture img {
  height: 48px;
  width: 48px;
}

.speakers .speaker .info {
  width: 78%;
  text-align: left;
}

.speakers .speaker .info .color {
  margin-top: 5px;
  margin-right: 5px;
}

.speakers .speaker .info .color .picto {
  width: 12px;
  height: 12px;
  border-radius: 2em;
}

.speakers .speaker .row {
  display: flex;
  flex-direction: row;
}

.speakers .speaker .actions {
  display: flex;
  width: 30%;
  padding-right: 5px;
  justify-content: space-between;
}`, "",{"version":3,"sources":["webpack://./src/applications/appcode/appcomponents/speakerslist/speakerslist.css"],"names":[],"mappings":"AAAA;EACE,kBAAkB;EAClB,kBAAkB;AACpB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;IACI,mBAAmB;IACnB,mBAAmB,EAAE,+BAA+B;AACxD;;AAEA;IACI,yBAAyB,EAAE,8BAA8B;IACzD,mBAAmB,EAAE,kCAAkC;IACvD,2CAA2C,EAAE,wCAAwC;AACzF;;AAEA;IACI,UAAU;AACd;;AAEA;EACE,YAAY;EACZ,kBAAkB;EAClB,aAAa;AACf;;AAEA;EACE,UAAU;EACV,YAAY;EACZ,kBAAkB;AACpB;;AAEA;EACE,YAAY;EACZ,WAAW;AACb;;AAEA;EACE,UAAU;EACV,gBAAgB;AAClB;;AAEA;EACE,eAAe;EACf,iBAAiB;AACnB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,UAAU;EACV,kBAAkB;EAClB,8BAA8B;AAChC","sourcesContent":[".speakers h2 {\n  margin-bottom: 5px;\n  text-align: center;\n}\n\n.speakers .add {\n  text-align: center;\n}\n\n.speakers .list::-webkit-scrollbar-track {\n    border-radius: 20px;\n    background: #efefef; /* color of the tracking area */\n}\n  \n.speakers .list::-webkit-scrollbar-thumb {\n    background-color: #0075ff; /* color of the scroll thumb */\n    border-radius: 20px; /* roundness of the scroll thumb */\n    border: 1px solid var(--default-icon-color); /* creates padding around scroll thumb */\n}\n\n.speakers .list::-webkit-scrollbar{\n    width:12px;\n}\n\n.speakers .speaker {\n  padding: 5px;\n  margin-bottom: 5px;\n  display: flex;\n}\n\n.speakers .speaker .picture {\n  width: 22%;\n  margin: auto;\n  text-align: center;\n}\n\n.speakers .speaker .picture img {\n  height: 48px;\n  width: 48px;\n}\n\n.speakers .speaker .info {\n  width: 78%;\n  text-align: left;\n}\n\n.speakers .speaker .info .color {\n  margin-top: 5px;\n  margin-right: 5px;\n}\n\n.speakers .speaker .info .color .picto {\n  width: 12px;\n  height: 12px;\n  border-radius: 2em;\n}\n\n.speakers .speaker .row {\n  display: flex;\n  flex-direction: row;\n}\n\n.speakers .speaker .actions {\n  display: flex;\n  width: 30%;\n  padding-right: 5px;\n  justify-content: space-between;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
